import { render, staticRenderFns } from "./EditSence.vue?vue&type=template&id=2f9ccbfc&scoped=true&"
import script from "./EditSence.vue?vue&type=script&lang=ts&"
export * from "./EditSence.vue?vue&type=script&lang=ts&"
import style0 from "./EditSence.vue?vue&type=style&index=0&id=2f9ccbfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ccbfc",
  null
  
)

export default component.exports